import {
  Component,
  Input,
  Output,
  OnChanges,
  EventEmitter,
} from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";
import { faChartLine, faArrowToBottom } from "@fortawesome/pro-light-svg-icons";
import * as Highcharts from "highcharts";
import { CompsTable } from "src/app/comps-page/comps-page.model";
@Component({
  selector: "app-industry-page-chart-section",
  templateUrl: "./industry-page-chart-section.component.html",
  styleUrls: ["./industry-page-chart-section.component.scss"],
})
export class IndustryPageChartSectionComponent implements OnChanges {
  @Input() chartType: string;
  @Input() chartFilters: Dictionary<any>;
  @Input() industry: string;
  @Input() compsTableData: CompsTable;
  @Input() compsDataReady: boolean;
  @Input() compsMetaReady: boolean;
  @Input() lineHasTotal: boolean;
  @Input() estimatePeriodOptions: Array<string>;
  @Input() tabName: string;
  @Output() onEstimatePeriodChange: EventEmitter<any> = new EventEmitter();
  @Output() onChartInstanceChange: EventEmitter<any> = new EventEmitter();

  radioValue = "top10";
  dataToUse: Dictionary<any> = {};
  downloadOptVisible = false;
  chartInstance: Highcharts.Chart;

  //icons
  faChartLine = faChartLine;
  faArrowToBottom = faArrowToBottom;
  yearTypeFilterVisible = false;
  yearTypeApplied = false;
  yearTypePopoverOpen = false;

  ngOnChanges() {
    this.dataToUse = {
      lines: this.chartFilters.lines,
      lineInfo: this.chartFilters.lineInfo,
      scaleType: this.chartFilters.scaleType,
      dataView: this.chartFilters.dataView,
      tickers: this.chartFilters.tickers,
      selectedTickersInfo: this.chartFilters.selectedTickersInfo,
      seriesInfo: {},
      hoveredTicker: "",
      currency: this.chartFilters.currency,
      revision: this.chartFilters.revisionPeriod,
      legendColors: ["#304da5", "#a53088", "#412504"],
      isSecondaryAxis: false,
      chartName: this.industry,
      periods: this.chartFilters.periods,
      chartTypeId:
        this.chartType === "industry-page-revision" ||
        this.chartType === "industry-page-total-revision" ||
        this.chartType === "industry-page-average-revision"
          ? "3"
          : "2",
      absVal: this.chartFilters.absVal,
      indexVal: this.chartFilters.indexVal,
      typeVal: this.chartFilters.typeVal,
      x: this.chartFilters.x,
      viewBy: this.chartFilters.viewBy,
      companyids: this.chartFilters.companyids
        ? this.chartFilters.companyids
        : [],
      industryId: this.chartFilters.industryId
        ? this.chartFilters.industryId
        : undefined,
      dataReady:
        this.chartFilters.dataReady &&
        this.compsDataReady &&
        this.compsMetaReady,
      tickerIds: this.chartFilters.tickerIds,
      tabName: this.tabName,
      respectivePeriodData: this.chartFilters.respectivePeriodData || [],
      periodType: this.chartFilters.periodType,
    };
  }

  onChartInstance(chartInstance: Highcharts.Chart) {
    if (chartInstance) {
      this.onChartInstanceChange.emit(chartInstance);
    }
  }
}
